






















































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import HeadLable from '@/components/HeadLable/index.vue'
import InputAutoComplete from '@/components/InputAutoComplete/index.vue'
import TabChange from './tabChange.vue'
import Empty from '@/components/Empty/index.vue'
import {
  getOrderDetailPage2,
  queryOrderDetailById2,
  passAudit2,
  getOrderListBy2,
  editPeResult,
  orderPrint,
  handlePeResult,
  deleteOrder,
  queryResvDetail, queryLevel, batchExportWord

} from '@/api/order'
import { AxiosPromise } from 'axios'
import { UserModule } from '@/store/modules/user'
import { errorExportInfor, exportInfor } from '@/api'

@Component({
  components: {
    HeadLable,
    InputAutoComplete,
    TabChange,
    Empty,
  },
})
export default class extends Vue {
  private defaultActivity: any = 0
  private orderStatics = {}
  private dialogOrderStatus = 0
  private row = {}
  private isAutoNext = true
  private loading = false
  private isTableOperateBtn = true
  private currentPageIndex = 0 //记录查看详情数据的index
  private orderId = '' //订单号
  private phone = '' //搜索条件的手机号
  private input = '' //搜索条件的订单号
  private zjh = '' //搜索条件的证件号
  private tjbh = '' //搜索条件的体检编号
  private age = '' //年龄
  private valueTime = []
  private dialogVisible = false //详情弹窗
  private cancelDialogVisible = false //取消，拒单弹窗
  private cancelDialogTitle = '' //取消，拒绝弹窗标题
  private cancelReason = ''
  private remark = '' //自定义原因
  private counts: number = 0
  private page: number = 1
  private pageSize: number = 10
  private tableData = []
  private diaForm = []
	private peResult = 0
  private isSearch: boolean = false
  private orderStatus = 0 //列表字段展示所需订单状态,用于分页请求数据
	private actionType = ''
	private ruleForm = {
			project: '',
			exception_if: '',
			exception: ''
		}
  private examResults = []
  private checkList: string[] = []
  private checkPeresult: any[]
  private level = 1
  private isPeResult2 = false
  private showNotification: boolean
  private notificationTitle: string
  private notificationText: string
  private timer: any = null



  private orderList = [
    {
      label: '全部体检',
      value: 0,
    },
    {
      label: '待体检',
      value: 1,
    },
    {
      label: '体检通过',
      value: 2,
    },
    {
      label: '体检未通过',
      value: 3,
    },
  ]


  created() {
    this.getLevel()

    // 初始化时尝试从 Vuex 中恢复状态
    const savedQuery = this.$store.getters.getPeListQuery;
    console.log(savedQuery)
    if (savedQuery) {
      console.log("if 执行成功")
      this.orderStatus = savedQuery.orderStatus || 0;
      this.page = savedQuery.page || 1;
      this.pageSize = savedQuery.pageSize || 10;
      this.input = savedQuery.input || '';
      this.phone = savedQuery.phone || '';
      this.zjh = savedQuery.zjh || '';
      this.tjbh = savedQuery.tjbh || '';
      this.valueTime = savedQuery.valueTime || [];

      // 初始化数据
      this.init(this.orderStatus)
      this.change(this.orderStatus)
    } else {
      console.log("if 执行失败")
      this.init(0);
    }
    // 启动自动刷新（每5分钟）
    this.timer = setInterval(() => {
      queryResvDetail().then(res => {
        if (res.data.code === 1 && res.data.data.status === 1) {
          this.showNotification = true;
          this.notificationTitle = '预约管理尚未审核';
        }
      });
    }, 300000); // 5000ms = 5秒
  }

  getLevel(){
    const username = UserModule.username

    queryLevel(username)
      .then((res)=>{
        if (res.data.code === 1) {
          this.level=res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message)
      })
  }

  beforeRouteLeave(to, from, next) {
    console.log("1111111111111111")
    // 离开列表页时保存当前状态到 Vuex
    this.$store.dispatch('savePeListQuery', {
      orderStatus: this.orderStatus,
      page: this.page,
      pageSize: this.pageSize,
      input: this.input,
      phone: this.phone,
      zjh: this.zjh,
      tjbh: this.tjbh,
      valueTime: this.valueTime
    });

    next();
  }


  initFun(orderStatus) {
    this.page = 1
    this.init(orderStatus)
  }

  change(activeIndex) {
    if (activeIndex === this.orderStatus) return
    this.init(activeIndex)
    this.input = ''
    this.phone = ''
    this.zjh = ''
    this.tjbh = ''
    this.valueTime = []
    this.dialogOrderStatus = 0
    this.$router.push('/dish')
    console.log(activeIndex, '接收到了子组件的index')
  }
//修改信息
//   private MessageHandle(st: string, username: string) {
//     console.log("13987319587032509")
//     if (st === 'add') {
//       console.log('2222222222222222222222222222')
//       // 在跳转前保存当前状态
//       this.$store.dispatch('savePeListQuery', {
//         orderStatus: this.orderStatus,
//         page: this.page,
//         pageSize: this.pageSize,
//         input: this.input,
//         phone: this.phone,
//         zjh: this.zjh,
//         valueTime: this.valueTime
//       });
//       this.$router.push('/orderDetails/add');
//     } else {
//       console.log("123431432413412412")
//       if (username === 'admin') return;
//       this.$router.push({
//         path: '/category/update',
//         query: { id: st }
//       });
//     }
//   }
  get isPassedPage() {
    return [2, 3].includes(this.orderStatus);
  }

  formatGender(row, column, cellValue) {
    if (cellValue === 1) {
      return '男';
    } else if (cellValue === 2) {
      return '女';
    }
    return cellValue;
  }

  formatDateTime(row, column, cellValue) {
    if (!cellValue) return '';
    // 将时间戳转换为Date对象
    const date = new Date(cellValue);

    // 检查日期是否有效
    if (isNaN(date.getTime())) {
      return cellValue; // 如果日期无效，返回原始值
    }

    // 格式化为 YYYY-MM-DD HH:mm 格式
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}`;
  }

  calculateAge(row, column, cellValue) {
    if (!cellValue) return '';
    const birthDate = new Date(cellValue.slice(6, 10), cellValue.slice(10, 12) - 1, cellValue.slice(12, 14));
    const now = new Date();
    let age = now.getFullYear() - birthDate.getFullYear();
    const monthDiff = now.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }
  //删除体检信息
  private DeleteHandle(type : string, id : string) {
    const confirmResult = confirm("确定要删除吗？")
    if(confirmResult) {
      deleteOrder(id).then(res => {
        if (res.data.code === 1) {
          this.$message.success("删除成功")
          this.init(Number(this.$route.query.status) || 0)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    } else {
      console.log("用户取消删除")
    }
  }

// 获取待体检，体检未通过，体检通过数量
  getOrderListBy3Status() {
    getOrderListBy2({})
      .then((res) => {
        if (res.data.code === 1) {
          this.orderStatics = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message)
      })
  }
  init(activeIndex) {
    this.isSearch = false; // 默认值
    // 如果 status 发生变化，则重置 page 为 1，否则保持原值
    const page = this.orderStatus !== activeIndex ? 1 : this.page;
    const params = {
      page: page,
      pageSize: this.pageSize,
      username: this.input || undefined,
      age: this.age || undefined,
      phoneNum: this.phone || undefined,
      certificateNumber: this.zjh || undefined,
      serviceCode:this.tjbh || undefined,
      beginTime: this.valueTime && this.valueTime.length > 0 ? this.valueTime[0] : undefined,
      endTime: this.valueTime && this.valueTime.length > 0 ? this.valueTime[1] : undefined,
      peResult: activeIndex || undefined
    };

    // 保存当前状态到 Vuex
    this.$store.dispatch('savePeListQuery', {
      orderStatus: activeIndex,
      page: page,
      pageSize: this.pageSize,
      input: this.input,
      phone: this.phone,
      zjh: this.zjh,
      tjbh: this.tjbh,
      valueTime: this.valueTime
    });

    getOrderDetailPage2({ ...params })
      .then((res) => {
        if (res.data.code === 1) {
          this.tableData = res.data.data.records;
          this.orderStatus = activeIndex;
          this.counts = Number(res.data.data.total);
          this.getOrderListBy3Status();
          if (
            this.dialogOrderStatus === 2 &&
            this.orderStatus === 2 &&
            this.isAutoNext &&
            !this.isTableOperateBtn &&
            res.data.data.records.length > 1
          ) {
            const row = res.data.data.records[0];
            this.goDetail(row.id, row.status, row);
          }
        } else {
          this.$message.error(res.data.msg);
        }
      })
      .catch((err) => {
        if (err.message === "Cannot read properties of undefined (reading 'url')") {
          this.$message.success("批量审核成功");
        } else {
          this.$message.error('请求出错了：' + err.message);
        }
      });
  }
//体检状态
  getOrderType(row: any) {
    if (row.peResult === 1) {
      return '待体检'
    } else if (row.peResult === 2) {
      return '体检未通过'
    }  else if (row.peResult === 3) {
      return '待审核'
    } else if (row.peResult === 4) {
      return '已审核'
    }
  }
  getProjectNameById(projectId) {
      if(projectId === 1){
        return '体征检查'
      }else if(projectId === 2){
        return '胸部正位片'
      }else if(projectId === 3){
        return '甲型肝炎病毒IGM抗体检测位片'
      }else if(projectId === 4){
        return '戊型肝炎病毒IGM抗体检测'
      }else if(projectId === 5){
        return '沙门菌培养及鉴定'
    }else if(projectId === 6){
        return '志贺菌培养及鉴定'
      }
    }
  getProjectIdByName(projectName) {
      if(projectName === '体征检查'){
        return 1
      }else if(projectName === '胸部正位片'){
        return 2
      }else if(projectName === '甲型肝炎病毒IGM抗体检测位片'){
        return 3
      }else if(projectName ==='戊型肝炎病毒IGM抗体检测' ){
        return 4
      }else if(projectName === '沙门菌培养及鉴定'){
        return 5
      }else if(projectName === '志贺菌培养及鉴定'){
				return 6
      }
    }
  // 新增体检
/*   private peHandle(row) {
    this.actionType = 'add'
    this.$router.push({
      path: '/dish/update',
      query: {  id: row.id,
                serviceId: row.serviceId,
                serviceCode: row.serviceCode }
        })

  } */

  get showBatchAuditButton() {
    return this.peResult === 2;
  }
  //打印体检单
  async showWord(row: any) {
    this.loading = true;
    const orderId = row.id;
    // this.init(Number(this.$route.query.peResult) || 1)
    // 调用orderPrint函数并处理返回的Promise
      try {
        const data = await orderPrint(orderId); // 直接等待orderPrint的结果
        // 假设res是包含PDF文档流数据的ArrayBuffer或其他可转换为Blob的格式
        const blob = new Blob([data], { type: 'application/pdf' });

        // 创建一个iframe用于打印
        const iframe = document.createElement('iframe');
        (iframe.style as any).frameborder = '0'; // 注意这里应该是'0'而不是'no'
        iframe.style.display = 'none';
        iframe.setAttribute('id', 'printPdf');
        iframe.setAttribute('name', 'printPdf');

        // 将Blob的URL设置为iframe的源
        iframe.src = window.URL.createObjectURL(blob);

        // 将iframe添加到文档中
        document.body.appendChild(iframe);
        // 监听iframe加载完成
        iframe.onload = () => {
            try {
                const ordonnance = iframe.contentWindow;
                if (ordonnance && ordonnance.document) {
                    ordonnance.document.execCommand('print', false, null);
                }
                // 清理：如果不需要显示PDF，这里不需要更改display属性
                // document.body.removeChild(iframe);
                // window.URL.revokeObjectURL(iframe.src);
              this.loading = false;
            } catch (error) {
              this.loading = false;
              console.error('Failed to print PDF:', error);
                // 显示错误或进行其他处理
            }

        };

        // document.body.appendChild(iframe);

/*        // 可选：添加一个按钮来控制iframe的显示
        const showPdfButton = document.createElement('button');
        showPdfButton.textContent = '显示PDF';
        showPdfButton.onclick = () => {
            iframe.style.display = iframe.style.display === 'none' ? 'block' : 'none';
        };
        document.body.appendChild(showPdfButton);*/

    } catch (error) {
        console.error('请求失败:', error);
    }
    this.init(this.orderStatus);
  }

  // 批量打印方法
  async batchPrint(row: any) {
    const idsToSend: string[] = [];
    if (row && typeof row === 'object' && row.hasOwnProperty('id') && !row.zjResult) {
      idsToSend.push(row.id);//todo ylh给我优化好这里，没必要发的就别在发请求
    }
    idsToSend.push(...this.checkList); // 将 checkList 中的所有 ID 添加到列表中

    // 去除重复的 ID（可选）
    const uniqueIds: number[] = [...new Set(idsToSend)].map(id => Number(id));

    try {
      // 调用批量导出接口（返回合并后的Word文件流）
      const data = await batchExportWord(uniqueIds);

      // 创建Word文件的Blob（注意MIME类型）
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      });

      // 触发浏览器下载
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `批量打印_${new Date().getTime()}.docx`; // 文件名
      document.body.appendChild(a);
      a.click();

      // 清理资源
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      this.$message.success('批量导出成功');
    } catch (error) {
      console.error('批量导出失败:', error);
      this.$message.error('批量导出失败，请重试');
    } finally {
      this.loading = false;
    }
  }

  errorExport() {
    this.$confirm('是否确认导出异常数据?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => { // 用户点击了确定按钮
      const params = {
        beginTime: this.valueTime && this.valueTime.length > 0 ? this.valueTime[0] : undefined,
        endTime: this.valueTime && this.valueTime.length > 0 ? this.valueTime[1] : undefined,
      };

      errorExportInfor({ begin: params.beginTime, end: params.endTime })
        .then((response) => {
          const { data } = response;
          let url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })); // 确保data是Blob类型，并设置正确的MIME类型
          var a = document.createElement('a');
          document.body.appendChild(a);
          a.href = url;
          a.download = `异常数据.xls`;
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error('导出失败:', error); // 处理导出失败的情况
        });
    }).catch(() => { // 用户点击了取消按钮
      // 这里可以处理取消操作，但通常不需要做什么，因为用户已经取消了导出
    });
  }

  // 查看详情
  async goDetail(id: any, peResult: number, row?: any) {
    this.dialogVisible = true
    this.dialogOrderStatus = peResult
    this.orderId = id
    queryOrderDetailById2({orderId: id })
      .then((res : any) => {
				if (res.data.code === 1) {
            if (res.data.data==""){
              this.$message.warning("请先打印体检单再录入")
          }
				// this.$message.success('体检信息查询成功！')
        const processedResults = res.data.data.map(item => ({
          ...item,
          projectName: this.getProjectNameById(item.project), // 假设这是一个将project ID转换为名称的函数
          result: item.exceptionIf, // 假设1表示正常，2表示异常
          exceptionDesc: item.exception,
          peData: item.peData // 假设这是从服务器获取的原始数据，需要进行处理
        })

      );
        this.examResults = processedResults;
       }

  })
  this.row = row || { id: this.$route.query.orderId, status: status }



  }
  private async submitForm(formName: any, row: any) {
    this.orderId = row.id;
    const valid = await (this.$refs[formName] as any).validate();
    if (valid) {
      // 遍历 examResults 数组并发送更新请求
      const promises: Promise<any>[] = this.examResults.map((item, index) => {
        // 构造发送给服务器的参数
        const params = {
          uid: this.orderId,
          project: this.getProjectIdByName(item.projectName),
          exceptionIf: item.result,
          exception: item.exceptionDesc, // 体检结果的异常描述
          peData: item.peData // 体检结果的原始数据
        };

        // 发送 API 请求
        return editPeResult(params)
          .then((res: any) => {
            if (res.data.code === 1) {
              // 更新成功
              this.$message.success(`第 ${index + 1} 条体检信息修改成功！`);
              // 如果需要，可以在这里处理更新后的数据，比如从服务器获取最新数据
            } else {
              // 更新失败
              this.$message.error(`第 ${index + 1} 条体检信息修改失败: ${res.data.msg}`);
            }
          })
          .catch((err: any) => {
            // 处理请求错误
            this.$message.error(`该用户已颁发证件，无法修改体检结果！`);
          });
      });

      // 等待所有请求完成
      await Promise.all(promises);

      // 所有请求完成后修改体检结果
   // await handlePeResult(Number(this.orderId));
      this.init(this.orderStatus);
    }
  }

//批量审核
  private async submitForm2(formName: any, row: any) {
    const idsToSend: string[] = [];
    if (row && typeof row === 'object' && row.hasOwnProperty('id') && !row.zjResult) {
      idsToSend.push(row.id);//todo ylh给我优化好这里，没必要发的就别在发请求
    }
    idsToSend.push(...this.checkList); // 将 checkList 中的所有 ID 添加到列表中

    // 去除重复的 ID（可选）
    const uniqueIds = [...new Set(idsToSend)];

    // 逐个发送请求
    for (const id of uniqueIds) {
      queryOrderDetailById2({ orderId: id })
        .then(async (res: any) => {
          if (res.data.code === 1) {
            const processedResults = res.data.data.map(item => ({
                ...item,
                projectName: this.getProjectNameById(item.project), // 假设这是一个将project ID转换为名称的函数
                result: item.exceptionIf, // 假设1表示正常，2表示异常
                exceptionDesc: item.exception,
                peData: item.peData // 假设这是从服务器获取的原始数据，需要进行处理
              })
            );
            this.examResults = processedResults;
          }
          // 构造发送给服务器的参数
          const promises: AxiosPromise<any>[] = this.examResults.map((item, index) => {
            const params = {
              uid: id,
              project: this.getProjectIdByName(item.projectName),
              exceptionIf: item.exceptionIf,
              exception: item.exceptionDesc, // 体检结果的异常描述
              peData: item.peData // 体检结果的原始数据
            };
            console.log(params)

            // 发送 API 请求
            return editPeResult(params)
          });
          await Promise.all(promises);
          // 所有请求完成后修改体检结果
          await handlePeResult(Number(id));
          this.init(this.orderStatus);
        })
    }
  }

  // 跳转添加预约信息
  private MessageHandle(st: string, username: string) {
    console.log('MessageHandle called with st:', st, 'username:', username);
    // 在跳转前保存当前状态到 Vuex
    this.$store.dispatch('savePeListQuery', {
      orderStatus: this.orderStatus,
      page: this.page,
      pageSize: this.pageSize,
      input: this.input,
      phone: this.phone,
      zjh: this.zjh,
      tjbh: this.tjbh,
      valueTime: this.valueTime
    });

    if (st === 'add') {
      console.log('2222222222222222222222222222');
      this.$router.push('/orderDetails/add');
    } else {
      if (username === 'admin') return;
      this.$router.push({
        path: '/orderDetails/add',
        query: { id: st }
      });
    }
  }



  // orderAccept(row: any) {
  //   this.orderId = row.id
  //   this.dialogOrderStatus = row.status
  //   orderAccept({ id: this.orderId })
  //     .then((res) => {
  //       if (res.data.code === 1) {
  //         this.$message.success('操作成功')
  //         this.orderId = ''
  //         this.dialogVisible = false
  //         this.init(this.orderStatus)
  //       } else {
  //         this.$message.error(res.data.msg)
  //       }
  //     })
  //     .catch((err) => {
  //       this.$message.error('请求出错了：' + err.message)
  //     })
  // }
  // 审核通过、不通过
  passAudit(row: any) {
			this.orderId = row.id
      this.dialogOrderStatus = row.peResult
      const hasError = this.examResults.some(item => item.result === 2);
      if (hasError) {
        this.$message.error('请检查异常描述！');
        return; // 如果存在错误，则直接返回，不执行后续操作
      }
      passAudit2({ id: this.orderId ,peResult: 3})
        .then((res) => {
          if (res.data.code === 1) {
            this.$message.success('操作成功')
            this.orderId = ''
            // this.dialogOrderStatus = 0
            this.dialogVisible = false
            this.init(this.peResult)
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          this.$message.error('请求出错了：' + err.message)
        })
        this.$router.push('/dish')


		}
  noPassAudit(row: any) {
			this.orderId = row.id
      this.dialogOrderStatus = row.peResult
      passAudit2({ id: this.orderId ,peResult: 2})
        .then((res) => {
          if (res.data.code === 1) {
            this.$message.success('操作成功')
            this.orderId = ''
            this.dialogVisible = false
            this.init(this.peResult)
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          this.$message.error('请求出错了：' + err.message)
        })
        this.$router.push('/dish')
      }

  handleClose() {
    this.dialogVisible = false
  }

  private handleSizeChange(val) {
    this.pageSize = val;
    this.$store.dispatch('savePeListQuery', {
      orderStatus: this.orderStatus,
      page: this.page,
      pageSize: this.pageSize,
      input: this.input,
      phone: this.phone,
      zjh: this.zjh,
      tjbh: this.tjbh,
      valueTime: this.valueTime
    });
    this.init(this.orderStatus);
  }

  private handleCurrentChange(val) {
    this.page = val;
    this.$store.dispatch('savePeListQuery', {
      orderStatus: this.orderStatus,
      page: this.page,
      pageSize: this.pageSize,
      input: this.input,
      phone: this.phone,
      zjh: this.zjh,
      valueTime: this.valueTime
    });
    this.init(this.orderStatus);
  }

// 更新路由查询参数（不触发页面刷新）
  private updateRouteQuery() {
    this.$router.push({
      path: this.$route.path,
      query: {
        ...this.$route.query,
        orderstatus: this.orderStatus.toString(),
        page: this.page.toString(),
        pageSize: this.pageSize.toString()
      }
    }).catch(err => {});
  }

  private handleSelectionChange(val: any) {
    let checkArr: any[] = []
    let checkArr2: any[] = []

    val.forEach((n: any) => {
      checkArr.push(n.id)
      checkArr2.push(n.peResult)
    })
    this.checkList = checkArr
    this.checkPeresult = checkArr2
  }

  private saveQuery() {
    this.$store.dispatch('savePeListQuery', {
      orderStatus: this.orderStatus,
      page: this.page,
      pageSize: this.pageSize,
      input: this.input,
      phone: this.phone,
      zjh: this.zjh,
      tjbh: this.tjbh,
      valueTime: this.valueTime
    });
  }

}
